import { FormikHelpers } from "formik";
import { useCreateCity } from "./api/createCity";
import CityForm from "./CityForm";


const CreateCity = ({handleCloseModal}: CreateCityProps)  => {
  const createCityMutation = useCreateCity({data: {}});

  const initialValues: IPostNewCity = {
    description: "",
    deleted: false
  };

  const handleSubmit = async (values: IPostNewCity, { setSubmitting }: FormikHelpers<IPostNewCity>): Promise<void> => {
    try {
      await createCityMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <CityForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreateCityProps {
  handleCloseModal: () => void;
}

export default CreateCity;